import { AgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";

/// DTOs

type BidderLotPurchaseDTO = {
    lotId: number,
    percentage: number
}

/// Queries

export const LotDataGetInvoicableLotsForBidderQuery: AgTechQuery<{ bidderId: number }, BidderLotPurchaseDTO[]> = {
    queryKey: ({ bidderId }) => ['InvoiceLotsForBidder', bidderId],
    query: async (props) => {
        return await props.http.getEntity({
            request: 'Lot/GetForInvoicingByBidder/' + props.inputData.bidderId
        });
    },
    content: {
        loadingText: 'Loading lots purchased by bidder...',
        failureText: 'Failed to load lots purchased by bidder.'
    }
}